import { FormControl, MenuItem, Select, Stack, TextField } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import FormatPhoneInput from '../../../components/FormatNumber/FormatPhoneInput';
import { Countries } from '../../../enums/countries';

function ContactInformationForm(): JSX.Element {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <Stack spacing={1} sx={{ flex: '1 0 160px' }}>
      <Controller
        name="firstName"
        control={control}
        render={({ field }) => (
          <TextField
            placeholder="First Name"
            size="small"
            {...field}
            error={!!errors.firstName}
            helperText={errors.firstName?.message}
          />
        )}
      />
      <Controller
        name="lastName"
        control={control}
        render={({ field }) => (
          <TextField
            placeholder="Last Name"
            size="small"
            {...field}
            error={!!errors.lastName}
            helperText={errors.lastName?.message}
          />
        )}
      />
      <Controller
        name="address"
        control={control}
        render={({ field }) => (
          <TextField
            placeholder="Address"
            size="small"
            {...field}
            error={!!errors.address}
          />
        )}
      />
      <Controller
        name="city"
        control={control}
        render={({ field }) => (
          <TextField
            placeholder="City"
            size="small"
            {...field}
            error={!!errors.citystate}
          />
        )}
      />
      <Controller
        name="state"
        control={control}
        render={({ field }) => (
          <TextField
            placeholder="State"
            size="small"
            {...field}
            error={!!errors.state}
            helperText={errors.state?.message}
          />
        )}
      />
      <Controller
        name="country"
        control={control}
        render={({ field: { onChange, value } }) => (
          <FormControl fullWidth>
            <Select
              size="small"
              id="country"
              fullWidth
              value={value}
              onChange={(data) => {
                onChange(data.target.value);
              }}
            >
              {Object.keys(Countries).map((country) => (
                <MenuItem key={country} value={country}>
                  {country}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />
      <Controller
        name="zipCode"
        control={control}
        render={({ field }) => (
          <TextField
            placeholder="Zip Code"
            size="small"
            {...field}
            error={!!errors.zipCode}
            helperText={errors.zipCode?.message}
          />
        )}
      />
      <Controller
        name="email"
        control={control}
        render={({ field }) => (
          <TextField
            placeholder="Email"
            size="small"
            type="email"
            {...field}
            error={!!errors.email}
          />
        )}
      />
      <Controller
        name="phoneNumber"
        control={control}
        render={({ field }) => (
          <TextField
            placeholder="Phone Number"
            size="small"
            {...field}
            error={!!errors.phoneNumber}
            InputProps={{
              // eslint-disable-next-line
              inputComponent: FormatPhoneInput as any
            }}
          />
        )}
      />
    </Stack>
  );
}

export default ContactInformationForm;
